import { isEmptyArray } from './array';
import _ from 'lodash'

/**
 * Parse nodes, children and id
 * @param {Array} arr 
 * @returns 
 */
const parse = (arr) => {
    return arr.map(obj => {             
        obj['nodes'] = parse(obj['nodes']);

        obj['name'] = obj['label'];
        obj['id'] = obj['structureId'];

        obj['nodes'].forEach(element => {
            element['father'] = obj['label'];
        })

        obj['children'] = obj['nodes'];

        return obj;
    })
}

/**
 * Get elements from three
 * @param {Object} obj 
 * @param {Array} list 
 * @returns 
 */
const parseTreeToArray = (obj) => {
    let returnValue = recursiveParseTreeToArray(obj, [])
    //returnValue = _.uniqBy(returnValue, 'key');    
    return returnValue;
}

/**
 * Get elements from three
 * @param {Object} obj 
 * @param {Array} list 
 * @returns 
 */
const recursiveParseTreeToArray = (obj, list = []) => {
    list.push(obj);
    if (typeof obj['nodes'] !== 'undefined' && obj['nodes'].length > 0) {
        obj['nodes'].forEach(element => {
            return recursiveParseTreeToArray(element, list);
        }
        )
    }
    return list;
}



/**
 * Get ids from three
 * @param {Object} obj 
 * @param {Array} list 
 * @returns 
 */
const recursiveGetIds = (obj, list) => {
    Object.keys(obj).forEach(key => {
        list.push(obj[key]['structureId']);

        if (typeof obj[key]['nodes'] !== 'undefined' && obj[key]['nodes'].length > 0) {
            return recursiveGetIds(obj[key]['nodes'], list);
        }
    })

    return list;
}

/**
 * Get elements from three
 * @param {Object} obj 
 * @param {Array} list 
 * @returns 
 */
const recursiveGetElements = (obj, list) => {
    Object.keys(obj).forEach(key => {
        list.push(obj[key]);

        if (typeof obj[key]['nodes'] !== 'undefined' && obj[key]['nodes'].length > 0) {
            return recursiveGetElements(obj[key]['nodes'], list);
        }
    })

    return list;
}

/**
 * Get elements from three
 * @param {Object} obj 
 * @param {Array} list 
 * @returns 
 */
const recursiveGetElementsByKey = (id, obj, list) => {
    if (obj && obj.length > 0) {
        obj.forEach(department => {

            if (department.id === id) {
                list.push(department);
            }

            if (department.nodes && !isEmptyArray(department.nodes)) {
                return recursiveGetElementsByKey(id, department.nodes, list);
            }

        })
    }


    return list;
}

/**
 * Get elements from three
 * @param {Object} obj 
 * @param {Array} list 
 * @returns 
 */
const recursiveGetElementsByName = (name, obj, list) => {
    if (obj && obj.length > 0) {
        obj.forEach(department => {
            //console.log(`department.name`, department.label)
            if (department.label.toLowerCase() === name.toLowerCase()) {
                list.push(department);
            }

            if (department.nodes && !isEmptyArray(department.nodes)) {
                return recursiveGetElementsByName(name, department.nodes, list);
            }

        })
    }


    return list;
}

/**
 * Get elements from three
 * @param {Object} obj 
 * @param {Array} list 
 * @returns 
 */
const recursiveGetMachinesByKey = (id, obj, list) => {
    let target = recursiveGetElementsByKey(id, obj, list);
    let childrenRecursive = recursiveGetElements(target, []);    
    childrenRecursive = childrenRecursive.filter((department) => {
        return (department.structureType.includes('quina') || department.structureType == "Ativo")
    });//comparado com quina pois M�quina nao funciona (devido ao acento)
    return childrenRecursive;
}

/**
 * Get elements from three
 * @param {Object} obj 
 * @param {Array} list 
 * @returns 
 */
const recursiveGetLinesByKey = (id, obj, list) => {
    let target = recursiveGetElementsByKey(id, obj, list);
    let childrenRecursive = recursiveGetElements(target, []);
    childrenRecursive = childrenRecursive.filter((department) => {
        return (department.structureType == "Linha")
    });//comparado com quina pois M�quina nao funciona (devido ao acento)
    return childrenRecursive;
}

const recursiveGetPilarsByKey = (id, obj, list) => {
    let target = recursiveGetElementsByKey(id, obj, list);
    let childrenRecursive = recursiveGetElements(target, []);
    childrenRecursive = childrenRecursive.filter((department) => {
        return (department.structureType == "Pilar")
    });//comparado com quina pois M�quina nao funciona (devido ao acento)
    return childrenRecursive;
}

/**
 * Get elements from three
 * @param {Object} obj 
 * @param {Array} list 
 * @returns 
 */
const recursiveGetLineParentByKey = (fatherId, obj) => {
    let target = recursiveGetParentByKey(fatherId, obj, []);
    var loop = 0;
    while (target.length != 0 && target[0].structureType != "Linha") {
        target = recursiveGetParentByKey(target.parent, obj, []);
        loop++;
        if (loop >= 15)
            return null;
    }

    if (target.length > 0)
        return target[0];
    
    return null;
}

/**
 * Get elements from three
 * @param {Object} obj 
 * @param {Array} list 
 * @returns 
 */
const recursiveGetParentByKey = (fatherId, obj, list) => {
    if (obj && obj.length > 0) {
        obj.forEach(department => {
            //console.log(`department.name`, department.label)
            if (department.id === fatherId) {
                list.push(department);
            }

            if (department.nodes && !isEmptyArray(department.nodes)) {
                return recursiveGetParentByKey(fatherId, department.nodes, list);
            }

        })
    }

    return list;
}

export { parse, parseTreeToArray, recursiveGetElements, recursiveGetIds, recursiveGetElementsByName, recursiveGetElementsByKey, recursiveGetLinesByKey, recursiveGetMachinesByKey, recursiveGetLineParentByKey, recursiveGetPilarsByKey };